import styled from 'styled-components';
import { compose, layout, LayoutProps, space, SpaceProps } from 'styled-system';

const Spacer = styled.div<SpaceProps & LayoutProps>(compose(layout, space));

export default Spacer;
